var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { loadAll, loadLast, update } from "framework/state/loader";
import { updateByCollectionResponse } from "framework/state/collection";
import { NoEntityError } from "framework/validation/validatableentity";
import { setEntityField } from "framework/state/setfield";
import { apiUpdatePartnershipState, apiGetAthletePartnerships, apiGetAthletePartnership, apiCreatePartnership, apiGetCompetitorPartnerships } from "./endpoint";
import { apiGetAthlete } from "public_app/athlete/endpoint";
import { AgeType, CompetitionClassType, DisciplineType, SeriesType } from "public_app/events/entity";
var NewPartnershipSubmissionStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
export var selectCustomIdt = { key: '*customIdt', name: "* zadat IDT", idt: null };
export var selectNewFemale = { key: '*newFemale', name: "* registrovat novou tanečnici", idt: null };
export var selectNewMale = { key: '*newMale', name: "* registrovat nového tanečníka", idt: null };
var setAvailablePeople = function (people) { return function (store) {
    store.setState(function (draft) {
        draft.newPartnership.availablePeople = people;
        draft.newPartnership.availablePeople.push(selectCustomIdt);
        draft.newPartnership.availablePeople.push(selectNewFemale);
        draft.newPartnership.availablePeople.push(selectNewMale);
    });
}; };
var filterPeople = function (personNumber) { return function (store) {
    store.setState(function (draft) {
        var filter = personNumber === 1 ? draft.newPartnership.filter1 : (personNumber === 2 ? draft.newPartnership.filter2 : null);
        var filtered = [];
        if (filter) {
            filtered = draft.newPartnership.availablePeople.filter(function (x) { return x.key[0] != '*'; }).filter(function (x) { var _a; return (_a = x.name) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase().includes(filter.trim().toLocaleLowerCase()); });
        }
        else {
            filtered = draft.newPartnership.availablePeople.filter(function (x) { return x.key[0] != '*'; });
        }
        if (filtered.length > 10) {
            var cutoff = filtered.length - 10;
            filtered = filtered.slice(0, 10);
            filtered.push({ key: '-', name: "...a další" + (cutoff >= 5 ? "ch" : "") + " " + cutoff, idt: null });
        }
        filtered.push(selectCustomIdt);
        filtered.push(selectNewFemale);
        filtered.push(selectNewMale);
        if (personNumber === 1) {
            draft.newPartnership.filteredPeople1 = filtered;
        }
        if (personNumber === 2) {
            draft.newPartnership.filteredPeople2 = filtered;
        }
    });
}; };
var NewPartnershipStateDefaults = __assign(__assign({}, LoadingStateDefaults), { errors: __assign({}, NoEntityError), entity: {
        idt1: null,
        idt2: null,
        registerSttAdult: false,
        registerLatAdult: false,
        registerSttSenior: false,
        registerLatSenior: false,
        registerCarribean: false,
        classSttAdult: null,
        classLatAdult: null,
        classSttSenior: null,
        classLatSenior: null,
        registeredCompetitorId: null,
    }, availablePeople: [], filteredPeople1: [], filteredPeople2: [], filter1: '', filter2: '', selectedPerson1: null, selectedPerson2: null, partnershipSeries: null, partnershipSeriesSelectVisible: true, registrationDialogOpenForPersonNumber: null, needToReloadAvailablePeople: false });
var resetPartnershipDataForNewAthletes = function () { return function (store) {
    store.setState(function (draft) {
        draft.newPartnershipSubmission.errors = __assign({}, NoEntityError);
        draft.newPartnership.entity.registerSttAdult = false;
        draft.newPartnership.entity.registerLatAdult = false;
        draft.newPartnership.entity.registerSttSenior = false;
        draft.newPartnership.entity.registerLatSenior = false;
        draft.newPartnership.entity.registerCarribean = false;
        draft.newPartnership.entity.classSttAdult = null;
        draft.newPartnership.entity.classLatAdult = null;
        draft.newPartnership.entity.classSttSenior = null;
        draft.newPartnership.entity.classLatSenior = null;
        draft.newPartnership.entity.registeredCompetitorId = null;
        draft.newPartnership.partnershipSeries = null;
        draft.newPartnership.partnershipSeriesSelectVisible = false;
    });
}; };
var resetForm = function () { return function (store) {
    store.setState(function (draft) {
        draft.newPartnershipSubmission.errors = __assign({}, NoEntityError);
        draft.newPartnership.entity.idt1 = null;
        draft.newPartnership.entity.idt2 = null;
        draft.newPartnership.entity.registerSttAdult = false;
        draft.newPartnership.entity.registerLatAdult = false;
        draft.newPartnership.entity.registerSttSenior = false;
        draft.newPartnership.entity.registerLatSenior = false;
        draft.newPartnership.entity.registerCarribean = false;
        draft.newPartnership.entity.classSttAdult = null;
        draft.newPartnership.entity.classLatAdult = null;
        draft.newPartnership.entity.classSttSenior = null;
        draft.newPartnership.entity.classLatSenior = null;
        draft.newPartnership.entity.registeredCompetitorId = null;
        draft.athlete1.collection = [];
        draft.athlete2.collection = [];
        draft.newPartnership.filter1 = '';
        draft.newPartnership.filter2 = '';
        draft.newPartnership.selectedPerson1 = null;
        draft.newPartnership.selectedPerson2 = null;
        draft.newPartnership.registrationDialogOpenForPersonNumber = null;
        draft.newPartnership.needToReloadAvailablePeople = false;
        draft.newPartnership.partnershipSeries = null;
        draft.newPartnership.partnershipSeriesSelectVisible = false;
    });
    store.dispatch(filterPeople(1));
    store.dispatch(filterPeople(2));
}; };
var resetFormDancesport = function () { return function (store) {
    store.setState(function (draft) {
        draft.newPartnership.entity.registerSttAdult = false;
        draft.newPartnership.entity.registerLatAdult = false;
        draft.newPartnership.entity.registerSttSenior = false;
        draft.newPartnership.entity.registerLatSenior = false;
        draft.newPartnership.entity.classSttAdult = null;
        draft.newPartnership.entity.classLatAdult = null;
        draft.newPartnership.entity.classSttSenior = null;
        draft.newPartnership.entity.classLatSenior = null;
    });
}; };
var resetFormCarribean = function () { return function (store) {
    store.setState(function (draft) {
        draft.newPartnership.entity.registerCarribean = false;
    });
}; };
var resetNewPartnershipErrors = function () { return function (store) {
    store.setState(function (draft) {
        draft.newPartnershipSubmission.errors = __assign({}, NoEntityError);
    });
}; };
var setNeedToReloadAvailablePeople = function (val) { return function (store) {
    store.setState(function (draft) {
        draft.newPartnership.needToReloadAvailablePeople = val;
    });
}; };
var cancelNewPersonRegistration = function () { return function (store) {
    store.setState(function (draft) {
        if (draft.newPartnership.registrationDialogOpenForPersonNumber === 1) {
            draft.newPartnership.filter1 = '';
            draft.newPartnership.selectedPerson1 = null;
            store.dispatch(filterPeople(1));
        }
        if (draft.newPartnership.registrationDialogOpenForPersonNumber === 2) {
            draft.newPartnership.filter2 = '';
            draft.newPartnership.selectedPerson2 = null;
            store.dispatch(filterPeople(2));
        }
        draft.newPartnership.registrationDialogOpenForPersonNumber = null;
    });
}; };
var selectPerson = function (personNumber, key) { return function (store) {
    if (key && key != '-') {
        store.setState(function (draft) {
            var person = draft.newPartnership.availablePeople.find(function (x) { return x.key == key; });
            if (personNumber === 1) {
                draft.newPartnership.selectedPerson1 = person;
                draft.newPartnership.entity.idt1 = person.idt;
            }
            if (personNumber === 2) {
                draft.newPartnership.selectedPerson2 = person;
                draft.newPartnership.entity.idt2 = person.idt;
            }
            if (person.key === "*newFemale") {
                draft.newPartnership.registrationDialogOpenForPersonNumber = personNumber;
            }
            if (person.key === "*newMale") {
                draft.newPartnership.registrationDialogOpenForPersonNumber = personNumber;
            }
        });
        updateForChangedIdt(personNumber, store);
    }
}; };
var setFilter1 = function (filter) { return function (store) {
    store.setState(function (draft) {
        draft.newPartnership.filter1 = filter;
    });
}; };
var setFilter2 = function (filter) { return function (store) {
    store.setState(function (draft) {
        draft.newPartnership.filter2 = filter;
    });
}; };
var submitPartnershipRegistration = function () { return function (store) {
    var state = store.getState();
    var newPartnership = state.newPartnership.entity;
    var series = state.newPartnership.partnershipSeries;
    var partnershipList = [];
    if (newPartnership.registerSttAdult) {
        var sttAdult = {
            idt1: newPartnership.idt1,
            idt2: newPartnership.idt2,
            discipline: DisciplineType.Standard,
            rankingAge: AgeType.Adult,
            selectedClass: newPartnership.classSttAdult,
            series: series
        };
        partnershipList.push(sttAdult);
    }
    if (newPartnership.registerLatAdult) {
        var latAdult = {
            idt1: newPartnership.idt1,
            idt2: newPartnership.idt2,
            discipline: DisciplineType.Latin,
            rankingAge: AgeType.Adult,
            selectedClass: newPartnership.classLatAdult,
            series: series
        };
        partnershipList.push(latAdult);
    }
    if (newPartnership.registerSttSenior) {
        var sttSenior = {
            idt1: newPartnership.idt1,
            idt2: newPartnership.idt2,
            discipline: DisciplineType.Standard,
            rankingAge: AgeType.Senior,
            selectedClass: newPartnership.classSttSenior,
            series: series
        };
        partnershipList.push(sttSenior);
    }
    if (newPartnership.registerLatSenior) {
        var latSenior = {
            idt1: newPartnership.idt1,
            idt2: newPartnership.idt2,
            discipline: DisciplineType.Latin,
            rankingAge: AgeType.Senior,
            selectedClass: newPartnership.classLatSenior,
            series: series
        };
        partnershipList.push(latSenior);
    }
    if (newPartnership.registerCarribean) {
        var carribean = {
            idt1: newPartnership.idt1,
            idt2: newPartnership.idt2,
            discipline: DisciplineType.Caribbean,
            rankingAge: AgeType.Adult,
            selectedClass: CompetitionClassType.Open,
            series: series
        };
        partnershipList.push(carribean);
    }
    var updater = function () { return apiCreatePartnership(partnershipList); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            var _a;
            updateByCollectionResponse(draft.newPartnershipSubmission, response);
            if (response.succeeded) {
                if (draft.newPartnershipSubmission.collection.length > 0) {
                    draft.newPartnership.entity.registeredCompetitorId = (_a = draft.newPartnershipSubmission.collection[0].competitorId) !== null && _a !== void 0 ? _a : null;
                }
            }
        });
    };
    update(store, updater, stateProducer, function (s) { return s.newPartnershipSubmission; });
}; };
var setNewPartnershipEntityField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.newPartnership, field, value, validator, storeInvalidValue);
    });
    if (field === "idt1") {
        updateForChangedIdt(1, store);
    }
    else if (field === "idt2") {
        updateForChangedIdt(2, store);
    }
    else {
        store.dispatch(resetNewPartnershipErrors());
    }
}; };
var setNewPartnershipSeries = function (value) { return function (store) {
    var resetDancesport = false;
    var resetCarribean = false;
    store.setState(function (draft) {
        draft.newPartnership.partnershipSeries = value;
        if (draft.newPartnership.partnershipSeries !== SeriesType.DanceSport) {
            resetDancesport = true;
        }
        if (draft.newPartnership.partnershipSeries !== SeriesType.Caribbean) {
            resetCarribean = true;
        }
    });
    if (resetDancesport) {
        store.dispatch(resetFormDancesport());
    }
    if (resetCarribean) {
        store.dispatch(resetFormCarribean());
    }
    store.dispatch(resetNewPartnershipErrors());
}; };
var setNewPartnershipSeriesSelectVisible = function () { return function (store) {
    store.setState(function (draft) {
        draft.newPartnership.partnershipSeriesSelectVisible = true;
    });
}; };
var updateForChangedIdt = function (personNumber, store) {
    var state = store.getState();
    if (personNumber === 1) {
        if (state.newPartnership.entity.idt1 === null) {
            store.setState(function (draft) {
                draft.athlete1.collection = [];
            });
        }
        else {
            store.dispatch(loadAthlete1(state.newPartnership.entity.idt1));
        }
    }
    if (personNumber === 2) {
        if (state.newPartnership.entity.idt2 === null) {
            store.setState(function (draft) {
                draft.athlete2.collection = [];
            });
        }
        else {
            store.dispatch(loadAthlete2(state.newPartnership.entity.idt2));
        }
    }
    store.dispatch(resetNewPartnershipErrors());
};
var AthleteStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var loadAthlete1 = function (idt) { return function (store) {
    var loader = function () { return apiGetAthlete(idt); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.athlete1, response);
        });
    };
    loadLast(store, loader, stateProducer, function (s) { return s.athlete1; });
}; };
var loadAthlete2 = function (idt) { return function (store) {
    var loader = function () { return apiGetAthlete(idt); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft.athlete2, response);
        });
    };
    loadLast(store, loader, stateProducer, function (s) { return s.athlete2; });
}; };
var PartnershipsStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError) });
var loadPartnershipsForAthlete = function (idt) { return function (store) {
    var loader = function () { return apiGetAthletePartnerships(idt); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.partherships, response);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.partherships; });
}; };
var loadPartnershipsForCompetitor = function (competitorId) { return function (store) {
    var loader = function () { return apiGetCompetitorPartnerships(competitorId); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.partherships, response);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.partherships; });
}; };
var PartnershipEditStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), dialogForTerminationIsOpened: false, dateOfTermination: null, vosTerminationDateNow: true });
var loadPartnership = function (id) { return function (store) {
    var loader = function () { return apiGetAthletePartnership(id); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.partnershipEdit, response);
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.partnershipEdit; });
}; };
var updatePartnershipState = function (id, idt1, idt2, state, dateOfTermination) {
    if (dateOfTermination === void 0) { dateOfTermination = null; }
    return function (store) {
        var updater = function () { return apiUpdatePartnershipState(id, state, idt1, idt2, dateOfTermination); };
        var stateProducer = function (store, _, response) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.partnershipEdit, response);
                if (response.succeeded) {
                    draft.partnershipEdit.dialogForTerminationIsOpened = false;
                }
            });
        };
        update(store, updater, stateProducer, function (s) { return s.partnershipEdit; });
    };
};
var openOrCloseDialogForPartnershipTermination = function (dialogIsOpened) { return function (store) {
    store.setState(function (draft) {
        draft.partnershipEdit.dialogForTerminationIsOpened = dialogIsOpened;
        draft.partnershipEdit.dateOfTermination = new Date();
    });
}; };
var setPartnershipTerminationDate = function (val) { return function (store) {
    store.setState(function (draft) {
        draft.partnershipEdit.dateOfTermination = val;
    });
}; };
var setPartnershipTerminationVariantNow = function (val) { return function (store) {
    store.setState(function (draft) {
        draft.partnershipEdit.vosTerminationDateNow = val;
    });
}; };
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { athleteIdt: null, competitorId: null, partherships: __assign({}, PartnershipsStateDefaults), partnershipEdit: __assign({}, PartnershipEditStateDefaults), newPartnership: __assign({}, NewPartnershipStateDefaults), newPartnershipSubmission: __assign({}, NewPartnershipSubmissionStateDefaults), athlete1: __assign({}, AthleteStateDefaults), athlete2: __assign({}, AthleteStateDefaults) });
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadPartnershipsForAthlete: loadPartnershipsForAthlete,
        loadPartnershipsForCompetitor: loadPartnershipsForCompetitor,
        loadPartnership: loadPartnership,
        updatePartnershipState: updatePartnershipState,
        openOrCloseDialogForPartnershipTermination: openOrCloseDialogForPartnershipTermination,
        setPartnershipTerminationDate: setPartnershipTerminationDate,
        setPartnershipTerminationVariantNow: setPartnershipTerminationVariantNow,
        setNewPartnershipEntityField: setNewPartnershipEntityField,
        resetPartnershipDataForNewAthletes: resetPartnershipDataForNewAthletes,
        resetForm: resetForm,
        submitPartnershipRegistration: submitPartnershipRegistration,
        setFilter1: setFilter1,
        setFilter2: setFilter2,
        setAvailablePeople: setAvailablePeople,
        selectPerson: selectPerson,
        filterPeople: filterPeople,
        cancelNewPersonRegistration: cancelNewPersonRegistration,
        setNeedToReloadAvailablePeople: setNeedToReloadAvailablePeople,
        resetNewPartnershipErrors: resetNewPartnershipErrors,
        setNewPartnershipSeries: setNewPartnershipSeries,
        setNewPartnershipSeriesSelectVisible: setNewPartnershipSeriesSelectVisible,
    },
    name: "Partnerships"
});
var useState = createHook(store);
export { StateDefaults as PartnershipsStateDefaults, useState as usePartnerships, };
